export interface SideMenuType {
  active?: boolean;
  selected?: boolean;
  id?: number;
  menutitle?: string;
  Items?: SideMenuType[];
  icon?: JSX.Element;
  title?: string;
  type?: string;
  children?: SideMenuType[];
  path?: string;
}

// eslint-disable
const Dashboardsvg = <i className="ri-home-8-line side-menu__icon"></i>; // eslint-disable-line
const AllowanceSvg = <i className="ti ti-users side-menu__icon"></i>; // eslint-disable-line
const StakingSvg = <i className="ti ti-list side-menu__icon"></i>; // eslint-disable-line
const SettingSvg = <i className="ti ti-settings side-menu__icon"></i>; // eslint-disable-line
// eslint-enable

export const MenuItems: SideMenuType[] = [
  {
    id: 1,
    Items: [
      {
        id: 2,
        path: `/dashboard`,
        icon: Dashboardsvg,
        title: "Dashboard",
        type: "link",
        active: false,
        selected: false,
      },
      {
        id: 3,
        icon: StakingSvg,
        title: "Staking",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            id: 31,
            path: `/staking/50`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 50",
          },
          {
            id: 32,
            path: `/staking/30`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 30",
          },
          {
            id: 33,
            path: `/staking/20`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 20",
          },
        ],
      },
      {
        id: 4,
        icon: AllowanceSvg,
        title: "Allowance",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            id: 41,
            path: `/allowance/50`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 50",
          },
          {
            id: 42,
            path: `/allowance/30`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 30",
          },
          {
            id: 43,
            path: `/allowance/20`,
            type: "link",
            active: false,
            selected: false,
            title: "APY: 20",
          },
        ],
      },
      {
        id: 5,
        path: `/setting`,
        icon: SettingSvg,
        title: "Setting",
        type: "link",
        active: false,
        selected: false,
      },
    ],
  },
];
